import React, { FC, useMemo } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

// constants
import SuccessRocket from '../../images/ApproveSuccessRocket.gif';

// components
import BasicButton from '../buttons/basicButton';
import BasicModal from './basicModal';

const CongratsText = [
    '😎Nice work!🙌',
    'Ready for Liftoff!🚀',
    '💫Message Launched!💫',
    '🪐Out of this world!👽',
    'There it goes!🌠',
];

interface StyledProps {
    isBold?: boolean;
}

interface RocketSuccessModalProps {
    text: string;
    handleClick: () => void;
    message?: string;
}

const RocketSuccessModal: FC<React.PropsWithChildren<RocketSuccessModalProps>> =
    ({
        text,
        handleClick,
        message = 'is live and will start sending to your customers shortly!',
    }) => {
        const randomIndex: number = useMemo(
            () => Math.floor(Math.random() * CongratsText.length),
            [],
        );

        return (
            <BasicModal width={'400px'} childContainerStyle={{ padding: 0 }}>
                <Container>
                    <RocketGif
                        src={SuccessRocket}
                        alt="Message approve success"
                    />
                    <Text> {CongratsText[randomIndex]}</Text>
                    <div>
                        <Name isBold>{text}</Name>
                        <Name>{message}</Name>
                    </div>
                    <BasicButton
                        isPrimary
                        name="Continue"
                        action={handleClick}
                        style={{ width: '100%' }}
                    />
                </Container>
            </BasicModal>
        );
    };
const Container = styled.div(() => ({
    padding: aampeTheme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: aampeTheme.spacing(3),
}));

const Text = styled.p(() => ({
    color: aampeTheme.colors.lime500,
    fontWeight: 'bold',
    fontSize: '20px',
}));
const Name = styled.p.withConfig({
    shouldForwardProp: (prop) => !['isBold'].includes(prop), // Prevent forwarding 'isBold' prop to DOM
})<StyledProps>(({ isBold }) => ({
    fontWeight: isBold ? 'bold' : 'normal',
    color: isBold
        ? aampeTheme.colors.textAccessibleWG01
        : aampeTheme.colors.gray600,
    fontSize: '14px',
    textAlign: 'center',
}));

const RocketGif = styled.img(() => ({
    width: '100%',
}));

export default RocketSuccessModal;
